import { render, staticRenderFns } from "./EndorsedDialog.vue?vue&type=template&id=6949bdcf&scoped=true&"
import script from "./EndorsedDialog.vue?vue&type=script&lang=js&"
export * from "./EndorsedDialog.vue?vue&type=script&lang=js&"
import style0 from "./EndorsedDialog.vue?vue&type=style&index=0&id=6949bdcf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6949bdcf",
  null
  
)

export default component.exports